import React from "react";
import { Check, CheckCheck } from "lucide-react";
import { whatsappMock } from "../content/landingContent";
import { useContentJson } from "../lib/useContent";

export const WhatsAppChatMock: React.FC = () => {
  const messages = useContentJson("whatsappMock.messagesJson", whatsappMock.messages);
  return (
    <div
      data-testid="whatsapp-chat-mock"
      className="rounded-[1.75rem] bg-[#E5DDD5] p-3 shadow-2xl border border-black/5 max-w-sm mx-auto"
    >
      <div className="rounded-2xl bg-[#075E54] px-4 py-3 flex items-center gap-3">
        <div className="h-9 w-9 rounded-full bg-white/20 flex items-center justify-center font-display font-bold text-white text-sm">
          MP
        </div>
        <div>
          <p className="text-white text-sm font-semibold leading-tight">Vendedor · MotorPRO</p>
          <p className="text-white/70 text-xs">en línea</p>
        </div>
      </div>

      <div className="mt-3 space-y-2.5 min-h-[260px]">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`flex ${msg.from === "seller" ? "justify-end" : "justify-start"}`}
          >
            <div
              data-testid={`whatsapp-message-${idx}`}
              className={`max-w-[80%] rounded-xl px-3.5 py-2 text-sm leading-snug shadow-sm ${
                msg.from === "seller" ? "bg-[#DCF8C6] text-neutral-800" : "bg-white text-neutral-800"
              }`}
            >
              {msg.text}
              <span className="flex items-center justify-end gap-1 mt-1 text-[10px] text-neutral-400">
                {msg.time}
                {msg.from === "seller" && <CheckCheck className="h-3 w-3 text-[#4FC3F7]" />}
              </span>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-3 text-center text-[11px] text-neutral-500 px-2">{whatsappMock.note}</p>
    </div>
  );
};
